import React, { useEffect, useState } from 'react';
import {
    Box,
    Flex,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Spinner,
    Button,
    Stack,
    Checkbox,
    Select
} from '@chakra-ui/react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

const GsummaryTwo = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const navigate = useNavigate();
    const cmpId = sessionStorage.getItem('cmp_id');
    // const userId = sessionStorage.getItem('user_id');
    const ledGroupType = sessionStorage.getItem('led_group_type');
    const [companyData, setCompanyData] = useState(null);
    const [userId, setUserId] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await axios.post(
                    `${ACCOUNTS_URL}/reports/G_summary/load_gsummary_two.php`,
                    {
                        cmp_id: cmpId,
                        user_id: userId,
                        led_group_type: ledGroupType,
                    }
                );
                console.log('====================================');
                console.log(response);
                console.log('====================================');
                setData(response.data.ledgers || []);
            } catch (error) {
                console.error('Error fetching GsummaryTwo data:', error);
            }
            setLoading(false);
        };

        if (cmpId && userId && ledGroupType) {
            fetchData();
        }
    }, [cmpId, userId, ledGroupType]);

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentData = data.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(data.length / rowsPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleRowClick = (ledGroupTyp) => {
        console.log('Selected led_group_id:', ledGroupTyp);
        sessionStorage.setItem('led_group_id', ledGroupTyp);
        navigate(`/accounts/g_summary/three`);
    };

    useEffect(() => {
        const storedUserId = sessionStorage.getItem('user_id');
        if (storedUserId) {
            setUserId(storedUserId);
        } else {
            setError('User not logged in or user_id not found in sessionStorage');
        }
    }, []);

    useEffect(() => {
        if (userId) {
            const fetchCompanyDetails = async () => {
                try {
                    const response = await fetch(`${ACCOUNTS_URL}/settings/company_details.php`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ user_id: userId }),
                    });

                    const data = await response.json();

                    if (data.status === 200) {
                        setCompanyData(data.data);
                    } else {
                        setError('No company found for this user.');
                    }
                } catch (err) {
                    setError('Error fetching company details.');
                }
            };

            fetchCompanyDetails();
        }
    }, [userId]); // Run when userId is set


    const printVoucher = () => {
        // Create an iframe element for printing
        const iframe = document.createElement('iframe');
        document.body.appendChild(iframe);

        // Ensure the iframe is not visible
        iframe.style.position = 'absolute';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';

        // Access the iframe's document for writing content
        const iframeDoc = iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(`
            <html>
                <head>
                    <title>Print Voucher</title>
                    <style>
                        body { font-family: 'Poppins', sans-serif; margin: 20px; }
                        .header, .footer { text-align: center; font-weight: bold; margin-bottom: 10px; }
                .header h2 { margin: 0; font-size: 24px; }
                .header p { margin: 0; font-size: 14px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 15px; }
                        th, td { border: 1px solid #ddd; padding: 8px; }
                        th { background-color: #0073e6; color: white; }
                        tr:nth-child(even) { background-color: #f2f2f2; }
                        tr:hover { background-color: #ddd; }
                        
                        /* Ensure styles are applied for print */
                        @media print {
                            th { background-color: #0073e6 !important; color: white !important; -webkit-print-color-adjust: exact; }
                            tr:nth-child(even) { background-color: #f2f2f2 !important; -webkit-print-color-adjust: exact; }
                            tr:hover { background-color: #ddd !important; -webkit-print-color-adjust: exact; }
                        }
                    </style>
                </head>
                <body>
               <div class="header">
    ${companyData.Company_Name && companyData.Company_Name.startsWith("No") === false
                ? `<h2>${companyData.Company_Name}</h2>`
                : ""}
    ${companyData.address && companyData.address.startsWith("No") === false
                ? `<p>${companyData.address}</p>`
                : ""}
    ${companyData.Tin && companyData.Tin.startsWith("No") === false
                ? `<p>GSTIN/UIN: ${companyData.Tin}</p>`
                : ""}
    ${companyData.Email_Id && companyData.Email_Id.startsWith("No") === false
                ? `<p>Email: ${companyData.Email_Id}</p>`
                : ""}
</div>
                    <table>
                        <thead>
                            <tr style="background-color: #0073e6; color: white;">
                                <th style="padding: 12px;">Particulars</th>
                                <th style="text-align: right; padding: 12px;">Debit</th>
                                <th style="text-align: right; padding: 12px;">Credit</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${currentData.map((item, index) => {
            return `
                                    <tr style="font-weight: 'bold';">
                                        <td style="padding: 12px 20px;">
                                            ${item.led_group_name}
                                        </td>
                                        <td style="padding: 12px 20px; text-align: right;">${item.debit}</td>
                                        <td style="padding: 12px 20px; text-align: right;">${item.credit}</td>
                                    </tr>
                                `;
        }).join('')}
                        </tbody>
                    </table>
                </body>
            </html>
        `);
        iframeDoc.close();

        // Print from the iframe and remove it afterward
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
    };
    return (
        <Box  mt={3} w='100%'  minH='750px' p={1}>
            <Flex
                className='sb'
                p={5}
                direction={{ base: "column", md: "row" }}
                justify="space-between"
            >
                <Flex align="center" mb={{ base: 4, md: 0 }} justify={{ base: "flex-start", md: "center" }}>
                    <Text mr={2}>Rows Per Page</Text>
                    <Select
                        width="100px"
                        value={rowsPerPage}
                        onChange={(e) => {
                            setRowsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                        borderColor="#E9EDF4"
                    >
                        <option value={12}>12</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                    </Select>
                    <Text ml={2}>Entries</Text>
                </Flex>
                <Button onClick={printVoucher}
                    w={{ base: '100%', md: 'auto' }}
                    mt={{ base: 2, md: 0 }}
                    ml={{ md: 4 }}
                    minW={{ md: '70px' }}>Print </Button>

            </Flex>

            <Box style={{ overflowX: 'auto' }} w={{ base: '367px', md: '100%' }}>
                {loading ? (
                    <Spinner size="xl" />
                ) : (
                    <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }} borderWidth='1px'>
                        <Thead>
                            <Tr>
                                <Th textAlign="center" textTransform="none" fontFamily="'Poppins', sans-serif">
                                    <Checkbox />
                                </Th>
                                <Th textTransform="none" fontFamily="'Poppins', sans-serif">Particulars</Th>
                                <Th textAlign="right" textTransform="none" fontFamily="'Poppins', sans-serif">Debit</Th>
                                <Th textAlign="right" textTransform="none" fontFamily="'Poppins', sans-serif">Credit</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {currentData.length > 0 ? (
                                currentData.map((item, index) => (
                                    <Tr key={index} onClick={() => handleRowClick(item.led_group_id)} cursor="pointer" >
                                        <Td py="12px" px="8px" textAlign="center">
                                            <Checkbox />
                                        </Td>
                                        <Td py="12px" px="20px">{item.led_group_name}</Td>
                                        <Td py="12px" px="20px" textAlign="right">{item.debit ? `${item.debit} ` : ''}</Td>
                                        <Td py="12px" px="20px" textAlign="right">{item.credit ? `${item.credit} ` : ''}</Td>
                                    </Tr>
                                ))
                            ) : (
                                <Tr>
                                    <Td colSpan={4} textAlign="center">No Data Found</Td>
                                </Tr>
                            )}
                        </Tbody>
                    </Table>
                )}
            </Box>

            <Flex justify="end" className='sb2'  borderTopWidth="1px" mt={1} p={3}>
                <Button onClick={() => handlePageChange(currentPage - 1)} isDisabled={currentPage === 1}>
                    Prev
                </Button>
                <Stack direction="row" mx={2}>
                    {currentPage > 1 && (
                        <>
                            <Button onClick={() => handlePageChange(1)}>1</Button>
                            {currentPage > 2 && <Text>...</Text>}
                        </>
                    )}
                    <Button backgroundColor='teal' color="white">{currentPage}</Button>
                    {currentPage < totalPages - 1 && (
                        <>
                            <Text>...</Text>
                            <Button onClick={() => handlePageChange(totalPages)}>{totalPages}</Button>
                        </>
                    )}
                </Stack>
                <Button onClick={() => handlePageChange(currentPage + 1)} isDisabled={currentPage === totalPages}>
                    Next
                </Button>
            </Flex>
        </Box>
    );
};

export default GsummaryTwo;
